var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "", id: "step19" } },
    [
      _c("StationWaterQualityChart", {
        attrs: {
          id: "waterqualitystationChart",
          requestData: _vm.graphRequestData,
        },
      }),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-actions",
            { staticClass: "card-bg-2 py-0 layout wrap", attrs: { wrap: "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "my-2 ml-0 mr-2",
                  attrs: {
                    disabled: _vm.hasDepthHeightData,
                    color: "info",
                    id: "step18",
                  },
                  on: { click: _vm.generateGraph },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("insert_chart"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm.$t("Button.Generate_Graph"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "my-2 ml-0 mr-2",
                  on: {
                    click: function ($event) {
                      return _vm.generateTabular()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("storage")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm.$t("Button.View_As_Tabular"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "my-2 ml-0",
                  attrs: { loading: _vm.loadingDownloadData },
                  on: { click: _vm.downloadData },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("save_alt")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm.$t("Button.DownloadExcelReport"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { background: "white" } },
            [
              _c(
                "v-alert",
                {
                  staticClass: "ma-0",
                  attrs: {
                    transition: "slide-y-transition",
                    outline: "",
                    type: "warning",
                    value: _vm.analyteMediaTypes.length === 0,
                  },
                },
                [
                  _c("div", { staticClass: "primary--text" }, [
                    _vm._v(
                      "This station does not have any sample analyses available"
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  staticClass: "ma-0",
                  attrs: {
                    transition: "slide-y-transition",
                    outline: "",
                    type: "warning",
                    value: _vm.hasDepthHeightData,
                  },
                },
                [
                  _c("div", { staticClass: "primary--text" }, [
                    _vm._v(
                      "Cannot generate graph for data with depth measurements"
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  staticClass: "ma-0",
                  attrs: {
                    transition: "slide-y-transition",
                    type: "info",
                    outline: "",
                    value:
                      _vm.showErrorBox &&
                      (_vm.noSelectionWarning || _vm.invalidDatesWarning),
                  },
                },
                [
                  _vm.noSelectionWarning
                    ? _c("div", { staticClass: "primary--text" }, [
                        _vm._v("Please select at least one analyte."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.invalidDatesWarning
                    ? _c("div", { staticClass: "primary--text" }, [
                        _vm._v("Please pick a date range."),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _vm.viewTabularRequestData
            ? [
                _c("StationWaterQualityTabular", {
                  attrs: {
                    id: "waterqualitystationChart",
                    requestData: _vm.viewTabularRequestData,
                  },
                  on: {
                    close: function ($event) {
                      return _vm.onTabularClose()
                    },
                    refresh: function ($event) {
                      return _vm.refreshCurrentMFDetails(
                        _vm.refreshParams.wqData
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("v-divider"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "card-bg-2", attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { staticClass: "divider-right", attrs: { xs12: "", md5: "" } },
                [
                  _c("v-card-title", { staticClass: "headline pb-0" }, [
                    _vm._v("Media Types"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0" },
                    [
                      _vm.analyteMediaTypes && _vm.analyteMediaTypes.length > 0
                        ? _c(
                            "v-radio-group",
                            {
                              attrs: { row: "" },
                              model: {
                                value: _vm.selectedMediaType,
                                callback: function ($$v) {
                                  _vm.selectedMediaType = $$v
                                },
                                expression: "selectedMediaType",
                              },
                            },
                            [
                              _vm._l(_vm.analyteMediaTypes, function (m) {
                                return [
                                  _c("v-radio", {
                                    key: m,
                                    attrs: {
                                      color: "info",
                                      label: m,
                                      value: m,
                                    },
                                  }),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.analyteMediaTypes || _vm.analyteMediaTypes == 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "py-4 secondary--text text--lighten-1",
                            },
                            [
                              _vm._v(
                                "\n            There are no media types available\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Date Range"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0" },
                    [
                      _c("DateRange", {
                        attrs: {
                          rounded: "",
                          solo: "",
                          minDate: _vm.minDate,
                          maxDate: _vm.maxDate,
                          selectedRange: _vm.selectedRange,
                          availableDateRange: {
                            start: _vm.minDate,
                            end: _vm.maxDate,
                          },
                          "min-max-placeholder": _vm.formats.prettyDateFormat,
                          shortcutPrefix: "Show",
                          shortcuts: _vm.shortcuts,
                          "no-arrows": "",
                          data: _vm.availableData,
                          shortcutKey: _vm.shortcutKey,
                          loadingValue: _vm.loadingValue,
                        },
                        on: {
                          "update:selectedRange": function ($event) {
                            _vm.selectedRange = $event
                          },
                          "update:selected-range": function ($event) {
                            _vm.selectedRange = $event
                          },
                        },
                        model: {
                          value: _vm.dates,
                          callback: function ($$v) {
                            _vm.dates = $$v
                          },
                          expression: "dates",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("WaterQualityGuideline", {
                    attrs: {
                      selectedMedia: _vm.selectedMediaType,
                      shouldSetDefaultSelection: "",
                      id: "step16",
                    },
                    on: { onGuidelineSelect: _vm.onGuidelineSelectHandler },
                  }),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Options"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0" },
                    [
                      _c(
                        "div",
                        { staticClass: "body-2 baseline" },
                        [
                          _vm._v(
                            "\n            Include QA/QC sample data\n            "
                          ),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                "open-on-hover": "",
                                "open-delay": 400,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass: "clickable ml-2",
                                            attrs: { color: "primary" },
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                  info_outline\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-card",
                                [
                                  _c("v-card-text", [
                                    _vm._v(
                                      "\n                  Include data from QA/QC replicate samples.\n                "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-1 mb-0",
                          attrs: { row: "" },
                          model: {
                            value: _vm.includeQaQc,
                            callback: function ($$v) {
                              _vm.includeQaQc = $$v
                            },
                            expression: "includeQaQc",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { color: "info", label: "Yes", value: true },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: { color: "info", label: "No", value: false },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Download Options"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0" },
                    [
                      _c(
                        "div",
                        { staticClass: "body-2 baseline" },
                        [
                          _vm._v("\n            Report Format\n            "),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                "open-on-hover": "",
                                "open-delay": 400,
                                "close-delay": 400,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass: "clickable ml-2",
                                            attrs: { color: "primary" },
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                  info_outline\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _vm._v(
                                        "\n                  Only the standard excel format is available at the moment. For other formats, try the "
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            to: {
                                              name: "discreteDataQueryReport",
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Discrete Data Query Report\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(".\n                "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-1 mb-4",
                          attrs: { value: true, row: "" },
                        },
                        [
                          _c("v-radio", {
                            attrs: { color: "info", value: true },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "font-weight-" },
                                        [_vm._v("Standard")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "caption" }, [
                                        _vm._v("Excel"),
                                      ]),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "body-2 baseline" },
                        [
                          _vm._v(
                            "\n            Include Envirodata analyte name in report\n            "
                          ),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                "open-on-hover": "",
                                "open-delay": 400,
                                "close-delay": 400,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            staticClass: "clickable ml-2",
                                            attrs: { color: "primary" },
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                  info_outline\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-card",
                                [
                                  _c("v-card-text", [
                                    _vm._v(
                                      "\n                  Add a column in the excel report to show the envirodata analyte name."
                                    ),
                                    _c("br"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-radio-group",
                        {
                          staticClass: "mt-1 mb-4",
                          attrs: { row: "" },
                          model: {
                            value: _vm.includeAnalyteName,
                            callback: function ($$v) {
                              _vm.includeAnalyteName = $$v
                            },
                            expression: "includeAnalyteName",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { color: "info", value: true },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "font-weight-" },
                                        [_vm._v("Yes")]
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: { color: "info", value: false },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "font-weight-" },
                                        [_vm._v("No")]
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticClass: "divider-left",
                  attrs: { xs12: "", md7: "", id: "step17" },
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "headline pb-0",
                          staticStyle: {
                            "align-items": "baseline",
                            display: "flex",
                          },
                        },
                        [_vm._v("\n            Analytes\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "rounded font-weight-regular",
                        attrs: {
                          "prepend-inner-icon": "search",
                          "hide-details": "",
                          clearable: "",
                          solo: "",
                          placeholder: "Search analytes",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.toggleCurrentItems($event)
                          },
                          "click:clear": function ($event) {
                            return _vm.clearSearch()
                          },
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-switch", {
                    staticClass: "switch",
                    attrs: {
                      label: "Show Envirodata Analyte Name",
                      color: "primary",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.showAnalyteName,
                      callback: function ($$v) {
                        _vm.showAnalyteName = $$v
                      },
                      expression: "showAnalyteName",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        "open-on-hover": "",
                        "open-delay": 400,
                        "close-delay": 400,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    staticClass: "clickable ml-2",
                                    attrs: { color: "primary" },
                                  },
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n              info_outline\n            "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { attrs: { "max-width": "500" } },
                        [
                          _c("v-card-text", [
                            _vm._v(
                              "\n              Internal EnviroData names are unique analyte names that help us manage analytes and potential synonyms.\n              Display names are not unique and the internal EnviroData name will provide an indication of the\n              difference between repeating display names.\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-item-group",
                    {
                      attrs: { mandatory: "", "active-class": "white--text" },
                      model: {
                        value: _vm.filterToggle,
                        callback: function ($$v) {
                          _vm.filterToggle = $$v
                        },
                        expression: "filterToggle",
                      },
                    },
                    [
                      _c(
                        "v-subheader",
                        {
                          staticStyle: { display: "inline", cursor: "default" },
                        },
                        [_vm._v("Show:")]
                      ),
                      _vm._v(" "),
                      _c("v-item", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ active, toggle }) {
                              return _c(
                                "v-chip",
                                {
                                  staticClass: "chipFilter",
                                  attrs: {
                                    small: "",
                                    color: active ? "primary" : "default",
                                    selected: active,
                                  },
                                  on: { click: toggle },
                                },
                                [_vm._v("All")]
                              )
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("v-item", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ active, toggle }) {
                              return _c(
                                "v-chip",
                                {
                                  staticClass: "chipFilter",
                                  attrs: {
                                    small: "",
                                    color: active ? "primary" : "default",
                                    selected: active,
                                  },
                                  on: { click: toggle },
                                },
                                [
                                  _c(
                                    "v-avatar",
                                    {
                                      staticClass: "chip-log-count",
                                      staticStyle: { "border-radius": "0px" },
                                    },
                                    [_vm._v(_vm._s(_vm.selected.length))]
                                  ),
                                  _vm._v(
                                    "\n              Selected\n            "
                                  ),
                                ],
                                1
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "analytesTable",
                    staticClass: "analyteTable",
                    attrs: {
                      search: _vm.search,
                      headers: _vm.headers,
                      items: _vm.items,
                      "select-all": "",
                      pagination: _vm.pagination,
                      "item-key": _vm.ID_KEY,
                      "custom-sort": _vm.customSorter,
                      "custom-filter": _vm.customFilter,
                      loading: _vm.loadingValue,
                    },
                    on: {
                      "update:pagination": function ($event) {
                        _vm.pagination = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "headers",
                        fn: function (props) {
                          return [
                            _c(
                              "tr",
                              [
                                _c(
                                  "th",
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        color: "primary",
                                        "input-value": props.all,
                                        indeterminate: props.indeterminate,
                                        primary: "",
                                        "hide-details": "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.toggleAll()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(props.headers, function (header) {
                                  return _c(
                                    "th",
                                    {
                                      key: header.text,
                                      class: [
                                        "column sortable",
                                        _vm.pagination.descending
                                          ? "desc"
                                          : "asc",
                                        header.value === _vm.pagination.sortBy
                                          ? "active"
                                          : "",
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeSort(header.value)
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("arrow_upward"),
                                      ]),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(header.text) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        },
                      },
                      {
                        key: "items",
                        fn: function (props) {
                          return [
                            _c(
                              "tr",
                              {
                                staticClass: "clickable",
                                attrs: { active: props.selected },
                                on: {
                                  click: function ($event) {
                                    props.selected = !props.selected
                                  },
                                },
                              },
                              [
                                _c(
                                  "td",
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        color: "info",
                                        "hide-details": "",
                                        "input-value": props.selected,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.DisplayAnalyte)),
                                ]),
                                _vm._v(" "),
                                _vm.showAnalyteName
                                  ? _c("td", [
                                      _vm._v(_vm._s(props.item.Analyte)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formatDateTime(
                                          props.item.FirstRecordDate,
                                          _vm.prettyDateTimeFormat
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formatDateTime(
                                          props.item.LastRecordDate,
                                          _vm.prettyDateTimeFormat
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-center" }, [
                                  _vm._v(_vm._s(props.item.NumberOfRecords)),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("water-quality-reports-error-modal", {
        attrs: {
          data: _vm.errorModalData,
          loading: _vm.errorModalLoading,
          customTitle: _vm.customTitle,
        },
        on: {
          download: _vm.onErrorModalCallback,
          cancel: _vm.onErrorModalClose,
        },
        model: {
          value: _vm.errorModal,
          callback: function ($$v) {
            _vm.errorModal = $$v
          },
          expression: "errorModal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }